export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";